var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useReducer } from 'react';
var LoadingStateActionType;
(function (LoadingStateActionType) {
    LoadingStateActionType["Loading"] = "LOADING";
    LoadingStateActionType["Error"] = "ERROR";
    LoadingStateActionType["Success"] = "SUCCESS";
})(LoadingStateActionType || (LoadingStateActionType = {}));
function buildReducer() {
    return (state, action) => {
        switch (action.type) {
            case LoadingStateActionType.Loading:
                return {
                    loading: true,
                    success: false,
                };
            case LoadingStateActionType.Success:
                return {
                    data: action.data,
                    loading: false,
                    success: true,
                };
            case LoadingStateActionType.Error:
                return {
                    error: action.error,
                    loading: false,
                    success: false,
                };
            default:
                throw new Error('Un-Implemented action type');
        }
    };
}
export default function useAsyncAction(func, onSuccess, onError) {
    const initialState = {
        loading: false,
        success: false,
    };
    const [state, dispatch] = useReducer(buildReducer(), initialState);
    const action = useCallback((...args) => __awaiter(this, void 0, void 0, function* () {
        dispatch({ type: LoadingStateActionType.Loading });
        try {
            const data = yield func(...args);
            dispatch({ data, type: LoadingStateActionType.Success });
            if (onSuccess) {
                onSuccess(data, args);
            }
            return data;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }
        catch (err) {
            dispatch({ error: err, type: LoadingStateActionType.Error });
            if (onError) {
                onError(err);
            }
        }
    }), [func, onError, onSuccess]);
    return [
        action,
        state.loading,
        {
            data: state.data,
            error: state.error,
            success: state.success,
        },
    ];
}
